export const SKIP_CONTACT_DETAILS_FIELDS = ['list_ids'];

export const tabOptions = [
  {
    id: 'details',
    name: 'contacts.tab_option.details',
  },
  {
    id: 'recentResponses',
    name: 'contacts.tab_option.recent_responses',
  },
];

export type RatingType =
  | 'promoter'
  | 'passive'
  | 'detractor'
  | 'positive'
  | 'neutral'
  | 'negative'
  | 'default';
export type RatingColorCodes = {
  bg: string;
  color: string;
  border: string;
};

export const DEFAULT_FILTER_VIEW_LENGTH = 3;
export const MAX_FILTER_VIEW_LENGTH = 30;

export const RATING_TYPES: {
  [key in RatingType]: RatingColorCodes;
} = {
  promoter: {
    bg: '#DEEEE4',
    color: '#058538',
    border: '#A7D8BB',
  },
  positive: {
    bg: '#DEEEE4',
    color: '#058538',
    border: '#A7D8BB',
  },
  passive: {
    bg: '#FFF1DD',
    color: '#DB9815',
    border: '#F2D9B3',
  },
  neutral: {
    bg: '#FFF1DD',
    color: '#DB9815',
    border: '#F2D9B3',
  },
  detractor: {
    bg: '#FAEAEA',
    color: '#C82124',
    border: '#FACECF',
  },
  negative: {
    bg: '#FAEAEA',
    color: '#C82124',
    border: '#FACECF',
  },
  default: {
    bg: 'var(--border-color)',
    color: 'var(--border-color)',
    border: 'var(--border-color)',
  },
};
